import { render, staticRenderFns } from "./AddAuthorizedSigner.vue?vue&type=template&id=01b81ec3&scoped=true"
import script from "./AddAuthorizedSigner.vue?vue&type=script&lang=ts"
export * from "./AddAuthorizedSigner.vue?vue&type=script&lang=ts"
import style0 from "./AddAuthorizedSigner.vue?vue&type=style&index=0&id=01b81ec3&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01b81ec3",
  null
  
)

export default component.exports